import styled from 'styled-components';
import { Scheduler as RMScheduler } from 'components/organisms/resource-management/scheduler/scheduler';

export const Scheduler = styled(RMScheduler)`
  .b-grid-headers-locked .b-grid-header[data-column-id='nameColumn'] {
    padding-left: var(--spacing-08);
  }
  .b-grid-subgrid-locked .b-grid-row {
    &.role .b-grid-cell {
      padding-left: var(--spacing-03);
    }
    &.team,
    &.user,
    &.assign_user_or_placeholder {
      .b-grid-cell.b-tree-cell {
        padding-left: 1px;
        .b-tree-cell-value {
          padding-left: var(--spacing-02);
        }
      }
    }
  }
  .b-schedulerpro[data-preset-id|='week'] {
    .b-sch-header-row {
      &.b-sch-header-row-0 {
        flex: 1;
      }
      &.b-sch-header-row-1 {
        flex: 0;
      }
    }
  }
`;
